import { createPrompt, fecthPrompts,getPromptById, deletePrompt, editPrompt } from '../api/api';


export const submitFormData = (fromdata) => async (dispatch) => {
  try {
    const res = await createPrompt(fromdata);
    dispatch({
      type: 'CREATE_PROMPT',
      payload: res.data
    })
    
    return res?.data
  } catch (error) {
    console.error('Failed to submit form:', error);
  }
}


export const getPrompts = (workspaceId) => async (dispatch) => {
    try {
        const res = await fecthPrompts(workspaceId);
        dispatch({ type: 'GET_PROMPTS', payload: res.data });

    } catch (err) {
        console.log(err);
    }
}


export const getpromptByID = (workspaceId,id)=> async (dispatch) => {
  try {
        const res = await getPromptById(workspaceId,id);
        if (res.status === 200) {
          console.log(res);
            dispatch({ type: 'GET_PROMPT_BY_ID', payload: res.data })
            return { status: "success", data: res.data };
        } else {
            dispatch({ type: 'GET_PROMPT_BY_ID_FAIL', payload: 'get prompt by id fail' });
            return { status: "fail", message: "edit prompt by id fail" };
        }

    } catch (err) {
        console.log(err);
        return { status: "error", message: err.message };
    }
}

export const destroyPrompt = (id) => async (dispatch) => {
  try {
    const res = await deletePrompt(id);
        if (res.status === 200) {
          console.log(res);
            dispatch({ type: 'PROMPT_DELETE_SUCCESS', payload: res.data })
        } else {
            dispatch({ type: 'PROMPT_DELETE_FAIL', payload: 'delete prompt by id fail' });
        }
  } catch (err) {
    console.log(err);
  }
}


export const updatePrompt = (formData, promptId) => async (dispatch) => {
  try{
    const res = await editPrompt(formData, promptId);
      if (res.status === 200) {
          dispatch({ type: 'PROMPT_EDIT_SUCCESS', payload: res.data });
          return { status: "success", data: res.data };
      } else {
          dispatch({ type: 'PROMPT_EDIT_FAIL', payload: 'edit prompt by id fail' });
          return { status: "fail", message: "update fail" };
      }
  } catch (err) {
    console.log(err);

  }
}